import { Col, Radio, Row } from 'antd'
import React, { memo } from 'react'

const options = [
  {
    value: 'excellent',
    label: 'Xuất sắc (Từ 90 đến 100 điểm)',
    style: {
      color: 'red',
    },
  },
  {
    value: 'good',
    label: 'Tốt (Từ 70 đến 89 điểm)',
    style: {
      color: '#0000FF',
    },
  },
  {
    value: 'completed',
    label: 'Hoàn thành (Từ 50 đến dưới 69 điểm)',
    style: {},
  },
  {
    value: 'notCompleted',
    label: 'Không hoàn thành (Dưới 50 điểm)',
    style: {},
  },
]

const InternalAssessmentRadio = ({ defaultSelectedValue }) => {
  // Xác định selected value trực tiếp từ prop
  const selectedValue = options.some(
    option => option.value === defaultSelectedValue
  )
    ? defaultSelectedValue
    : null

  return (
    <Radio.Group style={{ width: '100%' }} value={selectedValue}>
      <Row gutter={[16, 16]}>
        {options.map((option, index) => (
          <Col xs={24} sm={12} md={6} lg={6} key={index}>
            <div
              style={{
                padding: '8px',
                border:
                  selectedValue === option.value
                    ? '1px solid #1890ff'
                    : '1px solid #d9d9d9',
                borderRadius: '4px',
                fontWeight: selectedValue === option.value ? '600' : '500',
                backgroundColor: '#fafafa',
                transform:
                  selectedValue === option.value ? 'scale(1.05)' : 'scale(1)',
                transition: 'all 0.3s ease',
              }}>
              <Radio
                value={option.value}
                style={{
                  fontSize: '12px',
                  ...option.style,
                }}>
                {option.label}
              </Radio>
            </div>
          </Col>
        ))}
      </Row>
    </Radio.Group>
  )
}

export default InternalAssessmentRadio
